<template>
<div class="chapter">
<div class="inner_page">
<div id="Copyright" style="font-size:90%;">
<p class="copy">Published by<br/>Grub Street<br/>4 Rainham Close<br/>London<br/>SW11 6SS</p>
<p class="noindent">Copyright © Grub Street 2015<br/>Copyright text © Richard Pike 2015</p>
<p class="noindent"><b>A CIP record for this title is available from the British Library</b></p>
<p class="noindent"><b>ISBN-13: 9-781-909808-22-5</b><br/>
<b>Digital ISBN: 9-781-910690-86-4</b></p>
<p class="noindent">All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means electronic, mechanical, photocopying, recording or otherwise, without the prior permission of the copyright owner.</p>
<p class="noindent">Design by Sarah Baldwin<br/>Edited by Natalie Parker</p>
<p class="noindent">Printed and bound by Finidr, Czech Republic</p>
<p class="noindent">Grub Street Publishing only uses FSC (Forest Stewardship Council) paper for its books.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Copyright.vue?2417eed2